<template>
	<div class="loyalty-progress">
		<div
			v-for="index in total"
			:key="index"
			:class="{ complete: index <= progress }"
		></div>
	</div>
</template>

<style scoped>
.loyalty-progress {
	display: flex;
}

.loyalty-progress div {
	height: 20px;
	width: 20px;
	background: var(--gR-white);
	border: 1px solid var(--sk-grey2);
	margin-right: 13px;
	border-radius: 50%;
}

.loyalty-progress div.complete {
	background: var(--gR-teal-70);
	border: none;
}
</style>

<script>
export default {
	name: "UserLoyaltyProgress",
	props: {
		progress: {
			type: Number,
			default: 0
		},
		total: {
			type: Number,
			default: 0
		}
	}
}
</script>